import { useState } from 'react';
import { X } from 'lucide-react';
import { useCreateFolder } from '../../hooks/queries/useDossierFiles';
import { useAuthStore } from '../../store/useAuthStore';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

interface Props {
  dossierId: string;
  parentId: string | null;
  onClose: () => void;
}

export function CreateFolderModal({ dossierId, parentId, onClose }: Props) {
  const collaboratorId = useAuthStore((s) => s.collaborator?.id);
  const [name, setName] = useState('');
  const create = useCreateFolder(dossierId);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!collaboratorId || !name.trim()) return;
    try {
      await create.mutateAsync({ dossierId, parentId, name, createdBy: collaboratorId });
      onClose();
    } catch {
      /* affiché via create.isError */
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <form
        onSubmit={handleSubmit}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-md shadow-xl w-full max-w-sm"
      >
        <header className="flex items-center justify-between px-5 py-3 border-b border-neutral-200">
          <h2 className="font-heading text-lg font-semibold">Nouveau dossier</h2>
          <button type="button" onClick={onClose} className="text-neutral-400 hover:text-neutral-700">
            <X className="w-4 h-4" />
          </button>
        </header>
        <div className="px-5 py-4 space-y-3">
          <Input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nom du dossier"
            maxLength={100}
          />
          {create.isError && (
            <p className="text-xs text-red-600">
              {create.error instanceof Error ? create.error.message : 'Erreur'}
            </p>
          )}
        </div>
        <footer className="flex items-center justify-end gap-2 px-5 py-3 border-t border-neutral-200 bg-neutral-50">
          <Button variant="ghost" type="button" onClick={onClose} disabled={create.isPending}>
            Annuler
          </Button>
          <Button type="submit" disabled={!name.trim() || create.isPending}>
            {create.isPending ? 'Création…' : 'Créer'}
          </Button>
        </footer>
      </form>
    </div>
  );
}
